<template>
  <v-container
    fluid
    fill-height
    class="py-0"
  >
    <v-row>
      <v-col class="pt-0 pt-sm-3">
        <v-card>
          <v-card-title>
            <span class="primary--text">{{ account.shortName }}</span>&nbsp;{{ associationTitle }}
          </v-card-title>

          <v-card-text>
            <!--         <v-row class="align-center justify-right">
              <v-col>
                <v-text-field
                  v-model="userSearch"
                  label="Search"
                  dense
                  outlined
                  single-line
                  hide-details
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  autofocus
                />
              </v-col>
            </v-row> -->

            <!--  <v-data-table
              v-model="selectedCategories"
              :headers="categoryHeaders"
              :items="usersFiltered"
              :search="userSearch"
              :sort-by="['name']"
              hide-default-footer
              item-key=".key"
              class="cursor-pointer data-table-td-caption"
              :loading="usersLoading || saving || (showInactives && nonActivesLoading)"
              @click:row="item => selectedCategories = [item]"
            >     -->
            <!--             <v-data-table
              v-model="selectedCategories"
              :headers="categoryHeaders"
              :items="categoriesMapped"
              :search="categorySearch"
              :sort-by="['name']"
              hide-default-footer
              item-key=".key"
              class="cursor-pointer data-table-td-caption"
              :loading="usersLoading || saving || (showInactives && nonActivesLoading)"
              @click:row="item => selectedCategories = [item]"
            >                 -->
            <div class="v-data-table theme--light">
              <div class="v-data-table__wrapper">
                <table class=" data-table-td-caption">
                  <thead class="v-data-table-header">
                    <tr dense>
                      <template v-for="item in tableHeadersFiltered">
                        <th
                          :key="item"
                          class="text-left"
                        >
                          {{ item }}
                        </th>
                      </template>
                    </tr>
                  </thead>
                  <thead v-show="usersLoading || saving || (showInactives && nonActivesLoading)">
                    <tr class="v-datatable__progress">
                      <th
                        colspan="100%"
                        class="column"
                      >
                        <v-progress-linear indeterminate />
                      </th>
                    </tr>
                  </thead>

                  <tbody
                    is="transition-group"
                    v-if="!usersLoading"
                    name="flip-list"
                  >
                    <template v-for="item in usersSorted">
                      <tr
                        :key="(item.id || item['.key']) + item.qrySrc"
                        class="cursor-pointer"
                        style="transition: transform 0.5s; will-change: transform;"
                        @click="selectUser(item.id || item['.key'])"
                      >
                        <td>
                          <v-tooltip
                            bottom
                            class="text-no-wrap font-size-13"
                          >
                            <template #activator="{ on }">
                              <span v-on="on">
                                {{ item.name }}
                              </span>
                            </template>
                            <span>
                              UID: {{ item.id }}
                            </span>
                          </v-tooltip>
                        </td>
                        <td>{{ item.email }}</td>
                        <td v-if="association === 'Colleague'">
                          <v-switch
                            v-model="item.isAccountAdmin"
                            :disabled="userIsSelf(item)"
                            :readonly="saving"
                            :input-value="item.isAccountAdmin"
                            hide-details
                            small
                            @click.stop.prevent="toggleAccountAdmin(item.id)"
                          />
                        </td>
                        <td v-if="association === 'Colleague'">
                          <v-switch
                            v-model="item.active"
                            :disabled="userIsSelf(item)"
                            :readonly="saving"
                            :input-value="item.active"
                            hide-details
                            small
                            @click.stop.prevent="toggleBoolean(item['.key'] || item.id, 'active', item.active)"
                          />
                        </td>
                        <td v-else-if="association === 'Client'">
                          <span v-if="item.pendingLinks && item.pendingLinks.includes(account.id)">
                            pending
                          </span>
                          <v-switch
                            v-else
                            :readonly="saving"
                            :input-value="item.links && item.links.includes(account.id)"
                            hide-details
                            small
                            @click.stop.prevent="toggleClientLink(item.id, item.links)"
                          />
                        </td>
                        <td v-if="$store.getters.isAdmin && myAccount && association === 'Colleague'">
                          <v-switch
                            v-model="item.isAdmin"
                            :disabled="userIsSelf(item)"
                            :readonly="saving"
                            :input-value="item.isAdmin"
                            hide-details
                            small
                            @click.stop.prevent="toggleOLAdmin(item.id)"
                          />
                        </td>
                        <td v-if="association === 'Colleague'">
                          <v-switch
                            v-model="item.isSignatory"
                            :readonly="saving"
                            :input-value="item.isSignatory"
                            hide-details
                            small
                            @click.stop.prevent="toggleSignatory(item.id)"
                          />
                        </td>
                        <td class="text-no-wrap">
                          <v-tooltip bottom>
                            <template #activator="{ on }">
                              <span v-on="on">
                                {{ $formatFsTimestamp(item.created) || '' }}
                              </span>
                            </template>
                            <span>{{ item.created && item.created.toDate().toLocaleString() || '' }}</span>
                          </v-tooltip>
                        </td>
                        <td>{{ usersById[item.createdBy] ? usersById[item.createdBy].name : '' }}</td>
                        <td class="text-no-wrap">
                          <v-tooltip bottom>
                            <template #activator="{ on }">
                              <span v-on="on">
                                {{ $formatFsTimestamp(item.modified) || '' }}
                              </span>
                            </template>
                            <span>{{ item.modified && item.modified.toDate().toLocaleString() || '' }}</span>
                          </v-tooltip>
                        </td>
                        <td>{{ usersById[item.modifiedBy] ? usersById[item.modifiedBy].name : '' }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="display-flex align-center">
              <v-switch
                id="showInactives"
                v-model="showInactives"
                :disabled="!inactivesCount && association === 'Colleague'"
                hide-details
                small
                class="pl-2 mx-1 my-1 "
              >
                <span slot="label">
                  {{ showInactivesLabel }}
                </span>
              </v-switch>
              <v-spacer />
              <add-new-button
                v-if="showAddUserBtn"
                :is-disabled="disableAddUserBtn.value"
                :hover-value="disableAddUserBtn.reason || 'Add ' + association"
                @click="addUserDialog = !disableAddUserBtn.value"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <AddUserDialog
      v-if="association === 'Colleague'"
      :title="'Add ' + associationTitleSingular"
      :action="'Add ' + associationTitleSingular"
      :type="associationTitleSingular"
      :add-user-dialog="addUserDialog"
      :domain="association === 'Client' ? '' : domain"
      :saving="saving"
      @actionClick="addUser"
      @cancelClick="addUserDialog = false"
    />
    <v-dialog
      v-else
      v-model="addUserDialog"
      persistent
      max-width="500px"
    >
      <add-counterparty-form
        @cancel="addUserDialog = false"
        @counterpartyAdded="addUserDialog = false"
      />
    </v-dialog>
    <!-- TODO BETA use global snackbar -->
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      height="auto"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="snackbar.text" />
      <v-btn
        text
        style="max-width: 50px; width:50px;"
        @click.native="showSnackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import { fsdb, auth } from '../firebase'

import orderBy from 'lodash/orderBy'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import pick from 'lodash/pick'
import { isSingleUserAccount, isStandardAccount, isStandardBusinessAccount } from '@/dataAccess/accountTypes'

import AddNewButton from '@/components/AddNewButton'
import AddCounterpartyForm from '@/components/AddCounterpartyForm'
import AddUserDialog from '@/components/AddUserDialog'

const _ = { isEmpty, orderBy, get, pick }
if (process && process.env && process.env.NODE_ENV === 'development') {
  window._ = _
}

export default {
  name: 'Users',
  components: { AddNewButton, AddUserDialog, AddCounterpartyForm },
  props: {
    uid: { type: String, default: '' },
    association: { type: String, default: 'Colleague' },
    associationTitle: { type: String, default: 'Users' },
    associationTitleSingular: { type: String, default: 'User' }
  },
  data: function () {
    return {
      selectedUser: '',
      snackbar: { color: '', text: '', timeout: 6000 },
      showSnackbar: false,
      currentUid: this.uid,
      showInactives: false,
      addUserDialog: false,
      accountUsersLoading: true,
      clientUsersLoading: true,
      usersLoading: true,
      nonActivesLoading: false,
      sortFields: [],
      tableHeaders: [
        'Name', 'Email', 'Acc. Admin', 'Active', 'Signatory', 'Link Active', 'Admin', 'Created', 'Created By', 'Modified', 'Modified By'
      ],
      tableHeadersCounterparty: [
        'Name', 'Email', 'Created', 'Created By', 'Modified', 'Modified By'
      ],
      useProp: false,
      saving: false
    }
  },
  computed: {
    tableHeadersFiltered() {
      if (this.association === 'Counterparty') {
        return this.tableHeadersCounterparty.filter(item =>
          this.sortFields.some(item2 => item2.displayName === item)
        )
      }
      return this.tableHeaders.filter(item =>
        this.sortFields.some(item2 => item2.displayName === item)
      )
    },
    myAccount() {
      return this.account.id === this.$store.state.claims.accountId
    },
    accountAdmins() {
      return this.account.admins || []
    },
    accountOLAdmins() {
      return this.account.olAdmins || []
    },
    accountSignatories() {
      return this.account.signatories || []
    },
    allUsers() {
      var users = this.users.map(user => ({ ...user, qrySrc: 'client' }))
      if (this.showInactives && this.association === 'Client' && !this.nonActivesLoading) {
        users = users.concat(this.pendingClientUsers.map(user => ({ ...user, qrySrc: 'pending' })))
          .concat(this.inactiveClientUsers.map(user => ({ ...user, qrySrc: 'inactive' })))
      }
      return users
    },
    usersFiltered() {
      if (this.usersLoading) {
        return []
      }

      if (this.association === 'Client') {
        return this.allUsers
      }

      if (this.association === 'Colleague') {
        return this.usersWithRoles
      }

      if (this.association === 'Counterparty' && isStandardAccount(this.account.type)) {
        return this.usersWithRoles
      }

      return []
    },
    usersWithRoles() {
      return this.allUsers.filter(item => item.active || this.showInactives).map(user =>
        ({ ...user,
          isAccountAdmin: this.accountAdmins.includes(user.id),
          isAdmin: this.accountOLAdmins.includes(user.id),
          isSignatory: this.accountSignatories.includes(user.id)
        })
      )
    },
    usersSorted() {
      const sortFields = this.sortFields.reduce(
        (acc, item) => {
          acc.names.push(function (itemX) {
            return _.get(itemX, item.propName.split('.'))
          })
          acc.orders.push(item.desc ? 'desc' : 'asc')
          return acc
        },
        { names: [], orders: [] }
      )

      return _.orderBy(this.usersFiltered, sortFields.names, sortFields.orders)
    },
    usersById() {
      var users = [].concat(this.accountUsers, this.users).reduce((acc, item) => {
        if (typeof item !== 'undefined') {
          acc[item.id] = item
        }
        return acc
      }, {})
      users[this.$store.state.user.uid] = this.appUser
      return users
    },
    inactivesCount() {
      if (this.usersLoading) {
        return ''
      }
      if (this.association === 'Colleague') {
        return this.users.filter(item => !item.active).length
      } else if (this.association === 'Client') {
        // inactivesCount not shown for Clients, because a) they don't have their own collection(s) (yet) and
        // there's no summary value, yet.
        // TODO BETA improve pending and inactives handling
        return 0
      } else {
        return ''
      }
    },
    showInactivesLabel() {
      if (this.association === 'Colleague') {
        return !this.showInactives ? 'Show Inactives (' + this.inactivesCount + ')' : 'Showing Inactives'
      } else if (this.association === 'Client') {
        return !this.showInactives ? 'Show Pending & Inactives' : 'Showing Pending & Inactives'
      } else {
        return ''
      }
    },
    domain() {
      return this.account.domain
    },
    disableAddUserBtn() {
      const disabled = {
        reason: '',
        value: false
      }
      if (!this.account.active) {
        disabled.value = true
        disabled.reason = 'Account is not active'
      } else if (!this.user.emailVerified) {
        disabled.value = true
        disabled.reason = 'You cannot add users until your email is verified'
      } else if (this.featureEnabled('mfa') && !this.mfaEnabled) {
        disabled.value = true
        disabled.reason = 'You cannot add users until you have enabled multi-factor authentication'
      }
      return disabled
    }
  },
  watch: {
    'account': {
      handler:
      function (account) {
        this.rebindUsers()
        this.setSortFields()
        if (this.showInactives && this.association === 'Client') { this.showInactives = false }
      },
      deep: true
    },
    'showInactives': async function (newVal, oldVal) {
      if (newVal && this.association === 'Client') {
        // set the bindings to null, as these aren't realtime-y (except for admins)
        this.$store.commit('set_pendingClientUsersBinding', null)
        this.$store.commit('set_inactiveClientUsersBinding', null)
        this.nonActivesLoading = true
        await Promise.all(this.dispatchActions(['get_pendingClientUsers', 'get_inactiveClientUsers']))
        this.nonActivesLoading = false
      } else {
        this.$store.commit('set_pendingClientUsersBinding', null)
        this.$store.commit('set_inactiveClientUsersBinding', null)
      }
    }
  },
  beforeCreate() {
    this.dispatchActions(['checkAuth', 'get_appUser'])
    this.mapGetters(['featureEnabled'])
    this.mapStates(['user', 'appUser', 'account', 'mfaEnabled'])

    if (!this.$route.path.includes('admin')) {
      this.dispatchActions(['get_account'])
    }

    this.rebindUsers = function () {
      this.usersLoading = true
      if (this.$route.path.includes('users')) {
        if (this.$options.propsData.association === 'Counterparty') {
          this.$store.dispatch('get_counterpartyUsers').then(value => { this.usersLoading = false })
          this.mapStates([['users', 'counterpartyUsers']])
        } else {
          this.$store.dispatch('get_accountUsers').then(value => { this.usersLoading = false })
          this.mapStates([['users', 'accountUsers']])
        }
      } else {
        Promise.all([
          this.$store.dispatch('get_clientUsers'),
          this.$store.dispatch('get_accountUsers')
        ]).then(value => { this.usersLoading = false })
        this.mapStates([['users', 'clientUsers'], 'pendingClientUsers', 'inactiveClientUsers', 'accountUsers'])
      }
    }

    this.setSortFields = function () {
      var sortFields = [
        { displayName: 'Name', propName: 'name', desc: false },
        { displayName: 'Email', propName: 'email', desc: false }
      ]
      if (this.$route.path.includes('users')) {
        sortFields = sortFields.concat([
          { displayName: 'Acc. Admin', propName: 'isAccountAdmin', desc: false },
          { displayName: 'Active', propName: 'active', desc: false },
          { displayName: 'Signatory', propName: 'active', desc: false }

        ])
      } else {
        sortFields = sortFields.concat({ displayName: 'Link Active', propName: 'active', desc: false })
      }

      if (this.$store.getters.isAdmin && this.myAccount && this.association === 'Colleague') {
        sortFields.push({ displayName: 'Admin', propName: 'isAdmin', desc: false })
      }

      sortFields = sortFields.concat([
        { displayName: 'Created', propName: 'created', desc: false },
        { displayName: 'Created By', propName: 'createdBy', desc: false },
        { displayName: 'Modified', propName: 'modified', desc: false },
        { displayName: 'Modified By', propName: 'modifiedBy', desc: false }
      ])

      this.sortFields = sortFields
    }

    this.rebindUsers()
  },
  async created() {
    this.currentUid = this.currentUid || this.$store.state.user.uid
    this.setSortFields()
  },
  methods: {
    async addUser(details) {
      this.saving = true
      var user = {
        ...details,
        type: this.associationTitleSingular.replace(/\s/g, '').toLowerCase()
      }

      user.accountId = this.account.id
      user.accountShortName = this.account.shortName
      user.accountType = this.account.type

      try {
        if (this.association === 'Counterparty' && isStandardAccount(user.accountType)) {
          await this.$firePost('users/counterparty', auth, {
            name: user.name,
            email: user.email
          })
          this.snackbar = { color: 'success', text: 'User added.' }
        } else if (isStandardBusinessAccount(user.accountType)) {
          await this.$firePost('users/subuser', auth, {
            name: user.name,
            email: user.email,
            reqAccountId: this.account.id,
            reqAccountUserId: this.$store.getters.isAdmin ? this.account.admins[0] : this.appUser.id
          })
          this.snackbar = { color: 'success', text: 'User added.' }
        } else {
          const resp = await this.$firePost('users/addUserOrClient', auth, { user: user })

          if (resp.data === 'No Change') {
            this.snackbar = { color: 'warning', text: 'User already exists.' }
          } else {
            this.snackbar = { color: 'success', text: 'User added.' }
          }
        }

        this.addUserDialog = false
      } catch (e) {
        this.$Sentry.captureException(e)

        var snackText
        if ('response' in e) {
          // TODO BETA review API errors
          snackText = (e.response.data.error || JSON.stringify(e.response.data))
        } else {
          snackText = 'Error adding user. Try again.'
        }

        this.snackbar = {
          color: 'error',
          text: snackText
        }
      }

      this.showSnackbar = true
      this.saving = false
    },
    async toggleBoolean(uid, propName, value) {
      this.saving = true
      try {
        await fsdb
          .collection('users')
          .doc(uid)
          .update({ [propName]: !value })
      } catch (e) {
        this.snackbar = {
          color: 'error',
          text: 'Error saving change. Try again.'
        }
        this.showSnackbar = true
        this.$Sentry.captureException(e)
      }
      this.saving = false
    },
    async toggleUserRole(roleUrl) {
      this.saving = true

      try {
        await this.$firePost(roleUrl, auth)
      } catch (e) {
        const message = e.response.data.error || 'Error saving change. Try again.'
        this.snackbar = {
          color: 'error',
          text: message
        }
        this.showSnackbar = true
        this.$Sentry.captureException(e)
      } finally {
        this.saving = false
      }
    },
    async toggleAccountAdmin(uid) {
      await this.toggleUserRole(`users/toggleAccountAdmin/${uid}`)
    },
    async toggleSignatory(uid) {
      await this.toggleUserRole(`users/toggleSignatory/${uid}`)
    },
    async toggleOLAdmin(uid) {
      await this.toggleUserRole(`users/toggleOLAdmin/${uid}`)
    },
    async toggleClientLink(uid, links) {
      this.saving = true
      links = links || []
      var url = `users/toggleClientLink/${this.account.id}/${uid}/` + !(links.includes(this.account.id))

      try {
        await this.$firePost(url, auth)

        // TODO BETA this turns off showing inactives in order to clear the (non-realtime) bindings, which is not ideal.
        // A better solution would be separate collections for inactives and pendings so they can be realtime-y.
        this.showInactives = false
      } catch (e) {
        this.snackbar = {
          color: 'error',
          text: 'Error saving change. Try again.'
        }
        this.showSnackbar = true
        this.$Sentry.captureException(e)
      }
      this.saving = false
    },
    selectUser(uid) {
      if (this.selectedUser === uid) {
        this.selectedUser = ''
      } else {
        this.selectedUser = uid
      }
    },
    isSingleUserAccountOwner(user) {
      if (!user.userType) {
        return true
      }
      return user.userType !== 'counterparty'
    },
    isCounterpartyUser(user) {
      return user.userType && user.userType === 'counterparty'
    },
    userIsSelf(user) {
      return user.id === this.$store.state.user.uid
    },
    showAddUserBtn() {
      return !isSingleUserAccount(this.account.type) || this.association === 'Counterparty'
    }
  }
}
</script>
